import styled from "styled-components";

const StyledForm = styled.div` 
     margin: 1rem;
     padding: 1rem;


    h1 {
        text-align: center;
        color: rgba(6, 214, 160, 1);
        font-size: 2.44rem;
        margin-bottom: 1rem;
    }

    label {
        margin-bottom: 1rem;
    }

    select {
        padding: 1rem 0.5rem;
        border-radius: 10px;
        border: 1px solid #64748b;
    }

    /* input {
        outline: none;
        padding: 1rem 0.5rem;
        border-radius: 10px;
        border: 1px solid #64748b;
    } */

    .form__input:focus {
        border: 1px solid #4361ee;
    }

    .form__select:focus {
        border: 1px solid #4361ee;
    }

    .form__left {
        display: none;
    }

    .form__group {
        display: flex;
        flex-direction: column;
        margin-bottom: 1rem;
    }

    .form__input {
        outline: none;
        padding: 1rem 0.5rem;
        border-radius: 10px;
        border: 1px solid #64748b;
    }

    .form__label {
        margin-bottom: 1rem;
    }

    .form {
        display: flex;
        flex-direction: column;
    }

    .form__select {
        padding: 1rem 0.5rem;
        border-radius: 10px;
        border: 1px solid #64748b;

  }
    



   

    

    /* Large Screen */
@media (min-width: 992px) {
    .container {
      max-width: 1200px;
      margin: 5rem auto;
    }
  
    .form {
      display: flex;
      flex-direction: row;
      align-items: center;
    }

    .form__image{
        max-width: 90%;
        justify-content: center;
        margin-top: 70px;
    }
  
    .form__left {
      display: block;
      flex-basis: 60%;
      justify-content: center;
    }
  
    .form__right {
      flex-basis: 40%;
    }
  }

`;

export default StyledForm;